import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ignoreCompumaticPunches } from 'api/admin/timeClock/ignoreCompumaticPunches'
import { timeClockKeys } from './keys'

export function useIgnoreCompumaticPunchesMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ignoreCompumaticPunches,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: timeClockKeys.all,
      })
    },
  })
}
